import axios from "axios";

export default function() {
  axios.defaults.headers.post["Content-Type"] = "application/json";
  const csrfHeader = document.querySelector('meta[name="csrf-token"]');
  if (csrfHeader) {
    axios.defaults.headers.post["X-CSRF-Token"] = csrfHeader.getAttribute(
      "content"
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/csr_token.js